import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-48236a50"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "blueCheckout" };
const _hoisted_2 = { class: "container-fluid bg-white p-0 border-bottom" };
const _hoisted_3 = { class: "container" };
const _hoisted_4 = { class: "row mt-3" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "w-100 d-block" }, [
        /*#__PURE__*/ _createElementVNode("h1", { class: "h2-responsive mb-4 mt-2" }, "Kauf abschließen")
    ])
], -1));
const _hoisted_6 = { class: "col-md-7 col-12" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = {
    key: 0,
    class: "col-12 mb-4"
};
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", {
    class: "col-12 bg-white border rounded py-3 font7-responsive",
    style: { "border-left": "8px solid #a4ff78 !important" }
}, [
    /*#__PURE__*/ _createElementVNode("i", { class: "icon-brand_user font5" }),
    /*#__PURE__*/ _createTextVNode(" Hast Du bereits ein Nutzerkonto? "),
    /*#__PURE__*/ _createElementVNode("span", {
        class: "strong text-underline needs_login font-italic",
        style: { "cursor": "pointer" }
    }, " JETZT EINLOGGEN ")
], -1));
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = { class: "col-md-5 col-12" };
const _hoisted_12 = { class: "row blueStepFinal_WrapperSticky" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_sticky_cta_row = _resolveComponent("sticky-cta-row");
    const _component_blue_checkout_product_overview = _resolveComponent("blue-checkout-product-overview");
    const _component_address_block = _resolveComponent("address-block");
    const _component_shipping_option_selection = _resolveComponent("shipping-option-selection");
    const _component_payment_type_selection = _resolveComponent("payment-type-selection");
    const _component_checkout_newsletter_subscription = _resolveComponent("checkout-newsletter-subscription");
    const _component_blue_checkout_checkout_box = _resolveComponent("blue-checkout-checkout-box");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_sticky_cta_row, {
            target_element: ".JS_Sticky_Anchor_Confirm_Checkout",
            button_text: "Bestätigen und kaufen",
            additional_classes: "d-md-none"
        }),
        _createElementVNode("main", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_blue_checkout_product_overview)
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _hoisted_5,
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            (!_ctx.isLogin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                                : _createCommentVNode("", true),
                            _createVNode(_component_address_block),
                            _createVNode(_component_shipping_option_selection),
                            _createVNode(_component_payment_type_selection),
                            _createVNode(_component_checkout_newsletter_subscription, { checkout_type: "blue" })
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_blue_checkout_checkout_box)
                        ])
                    ])
                ])
            ])
        ])
    ], 64));
}
